<template>
  <section
    class="app-highlight py-12"
    aria-labelledby="app-highlight-title"
  >
    <div class="grid grid-cols-12 gap-8 lg:gap-12">
      <!-- IMAGE: semantic figure with figcaption for alt -->
      <div class="col-span-12 lg:col-span-6">
        <figure>
          <img
            :src="imageSrcLarge"
            :alt="imageAlt"
            class="w-full object-cover rounded-lg"
          >
          <figcaption class="sr-only">
            {{ imageAlt }}
          </figcaption>
        </figure>
      </div>

      <!-- TEXT CONTENT -->
      <div class="col-span-12 lg:col-span-6 h-full flex flex-col justify-center">
        <!-- Tag/badge -->
        <p class="text-sm bg-gray-50 rounded-md py-1 px-2 w-fit">
          {{ appHighlightTag }}
        </p>

        <!-- Heading with explicit ID for aria-labelledby -->
        <h2
          v-if="appHighlightTitle"
          id="app-highlight-title"
          class="text-6xl lg:text-8xl text-black font-bold "
        >
          {{ appHighlightTitle }}
        </h2>

        <!-- USP list region -->
        <KfRichText
          :use-checkmark-bullets="true"
          role="region"
          aria-labelledby="app-highlight-title "
        >
          <!-- Ensure this HTML is sanitized upstream -->
          <div v-html="appHighlightUspList" />
        </KfRichText>

        <!-- Download links group -->
        <div
          class="flex flex-col md:flex-row md:items-center mt-4"
          role="group"
          aria-label="App store download links"
        >
          <div class="flex flex-row md:flex-col items-center md:justify-center">
            <a
              v-if="appleAppStoreLink"
              :href="appleAppStoreLink"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download on the App Store"
            >
              <AppStoreButton
                aria-hidden="true"
                focusable="false"
              />
            </a>
            <AppHighlightsAppstoreRating />
          </div>
          <div class="flex flex-row md:flex-col items-center md:justify-center">
            <a
              v-if="googlePlayStoreLink"
              :href="googlePlayStoreLink"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Google Play"
            >
              <PlayStoreButton
                aria-hidden="true"
                focusable="false"
              />
            </a>
            <AppHighlightsPlaystoreRating />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import KfRichText from '@/components/base/rich-text/RichText.vue';
import AppStoreButton from '@/components/svg/AppStoreButton.vue';
import PlayStoreButton from '@/components/svg/PlayStoreButton.vue';
import AppHighlightsAppstoreRating from './AppHighlightsAppstoreRating.vue';
import AppHighlightsPlaystoreRating from './AppHighlightsPlaystoreRating.vue';

export default {
  name: 'AppHighlight',
  components: {
    AppStoreButton,
    PlayStoreButton,
    KfRichText,
    AppHighlightsAppstoreRating,
    AppHighlightsPlaystoreRating,
  },
  props: {
    appHighlightTitle: {
      type: String,
      required: true,
    },
    appHighlightTag: {
      type: String,
      default: '',
    },
    imageSrcLarge: {
      type: String,
      default: '',
    },
    imageAlt: {
      type: String,
      required: true,
    },
    appHighlightUspList: {
      type: String,
      default: '',
    },
    appleAppStoreLink: {
      type: String,
      default: null,
    },
    googlePlayStoreLink: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="postcss">
app-highlight {
  /* Screen-reader only utility */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .kf-image {
    img {
      @apply w-full;
    }
  }
}
</style>
